import React, { useState, useMemo } from 'react';
import { Controller } from 'react-hook-form';
import { c as classnames } from './index-2586sEvh.js';
import get from 'lodash/get';
import { useTranslation } from 'next-i18next';

/* eslint-disable jsx-a11y/label-has-associated-control */
const InputPassword = ({ control, errors, id = '', name, label = '', disabled, placeholder = '', autocomplete, title = '', variant = 'stacked', extraLabel = '', }) => {
    const { t } = useTranslation('');
    const [showPassword, setShowPassword] = useState(false);
    const errorText = get(errors, `${name}.message`, '');
    const isError = Boolean(errorText);
    const inputType = useMemo(() => (showPassword ? 'text' : 'password'), [showPassword]);
    const onClearField = (onChange) => {
        onChange('');
    };
    return (React.createElement(Controller, { control: control, name: name, render: ({ field: { value, onChange } }) => (React.createElement("div", { className: `form-control ${variant}-input` },
            label && (React.createElement("label", { className: "label", htmlFor: id }, label)),
            extraLabel && React.createElement("span", { className: "label" }, extraLabel),
            React.createElement("div", { className: "form-control-wrapper" },
                React.createElement("input", { name: name, id: id, type: inputType, value: value, disabled: disabled, placeholder: placeholder, autoComplete: autocomplete, className: classnames('input', { addon: true, error: isError }), onChange: onChange, title: title }),
                React.createElement("div", { role: "presentation", className: "input-addon", onClick: () => setShowPassword(prev => !prev) }, showPassword ? (React.createElement("span", { className: "icon-visibility" })) : (React.createElement("span", { className: "icon-visibility-off" }))),
                Boolean(value) && (React.createElement("div", { role: "presentation", className: "input-addon input-clear", onClick: () => onClearField(onChange) },
                    React.createElement("span", { className: "icon-close" })))),
            isError && (React.createElement("div", { className: "error", role: "alert" }, t(errorText))))) }));
};

export { InputPassword as I };
//# sourceMappingURL=InputPassword-LvKNz-2W.js.map
